import { styled } from "@mui/system";
import Button from "@mui/material/Button";

const ErrorButton = styled(Button)`
  && {
    background: linear-gradient(180deg, #ffffff 0%, #fff5f5 100%);
    color: #da2e23;
    border: 1.5px solid rgba(218, 46, 35, 0.7);
    border-radius: 6px;
    box-shadow: 0 1px 2px rgba(218, 46, 35, 0.15);
    text-transform: capitalize;
    min-width: 6.5rem;
    width: fit-content;
    padding: 0.55rem 1rem;
    font-weight: 500;
    letter-spacing: 0.2px;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
      background: #ffe3e3;
      box-shadow: 0 3px 8px rgba(218, 46, 35, 0.25);
      transform: translateY(-1px);
    }

    &:active {
      transform: translateY(0);
      box-shadow: 0 1px 2px rgba(218, 46, 35, 0.2);
    }

    &:disabled {
      background: #f2f2f2;
      color: #9e9e9e;
      border-color: #cfcfcf;
      box-shadow: none;
      cursor: not-allowed;
      transform: none;
    }
  }
`;

export default ErrorButton;
